import React, { useEffect, useState, useContext, useRef } from "react";
import HamburgerMenuHeader from "../../Header/DeliveryMenuHeader";
import { AuthContext } from "../../../context/AuthContext";
import {
  fetchDeliveryProfile,
  patchDeliveryProfile,
} from "../../../services/delivery_api";
import { useTranslation } from "react-i18next";

const DeliveryManageAccount = () => {
  const { user, login } = useContext(AuthContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const isMountedRef = useRef(true);

  // ✅ Single source of truth
  const [formData, setFormData] = useState({
    title: "Mr.",
    name: "",
    phoneNumber: "",
  });

  const [initialFormData, setInitialFormData] = useState({});

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchDeliveryProfileData();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchDeliveryProfileData = async () => {
    try {
      setLoading(true);

      const response = await fetchDeliveryProfile(); // ✅ GET API

      if (response) {
        const newFormData = {
          title: "Mr.",
          name: response.da_name || "",
          phoneNumber: response.phone_number || "",
        };

        setFormData(newFormData);
        setInitialFormData(newFormData);
      }
    } catch (error) {
      console.error("❌ Delivery profile fetch failed:", error);
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  };

  const handleSave = async () => {
    // Prevent save if nothing changed
    if (!isFormChanged) return;

    try {
      setLoading(true);

      const payload = {
        da_name: formData.name,
        phone_number: formData.phoneNumber,
      };

      const result = await patchDeliveryProfile(payload);

      if (result) {
        console.log("✅ Delivery profile updated");

        // ✅ Update AuthContext + localStorage consistency
        const updatedUser = {
          ...user,
          da_name: payload.da_name,
          phone_number: payload.phone_number,
        };

        const tokens = JSON.parse(localStorage.getItem("authTokens"));

        // Keep user_type same
        const user_type = user?.user_type || "delivery";

        login(tokens, updatedUser, user_type);

        // ✅ Update initial state to disable Save after success
        setInitialFormData(formData);

        alert("✅ Profile updated successfully");
      }
    } catch (err) {
      console.error("❌ Delivery update failed:", err);
      alert("❌ Failed to update profile.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = () => {
    if (window.confirm("Are you sure you want to delete your account?")) {
      console.log("🗑 Account deletion triggered");
      // TODO: delete account API
    }
  };

  const isFormChanged =
    JSON.stringify(formData) !== JSON.stringify(initialFormData);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f8fcff] to-[#d9ecff] flex flex-col">
      {/* ✅ Header */}
      <HamburgerMenuHeader
        title={t("manageYourAccount", "Manage Your Account")}
      />

      {/* ✅ Profile */}
      <div className="flex flex-col items-center mt-10">
        {/* Avatar */}
        <div className="w-20 h-20 rounded-full border-4 border-white shadow-lg flex items-center justify-center bg-blue-600 text-white text-3xl font-bold">
          {(formData.name || user?.da_name || "U").charAt(0).toUpperCase()}
        </div>

        {/* ✅ Form */}
        <div className="mt-8 w-full max-w-md px-6">
          {/* Name */}
          <div className="flex mb-4">
            <select
              value={formData.title}
              onChange={(e) =>
                setFormData({ ...formData, title: e.target.value })
              }
              className="border border-gray-300 rounded-l-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            >
              <option>Mr.</option>
              <option>Ms.</option>
              <option>Mrs.</option>
              <option>Dr.</option>
            </select>

            <input
              type="text"
              placeholder="Name"
              value={formData.name}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="flex-1 border border-gray-300 rounded-r-lg px-3 py-2 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Phone */}
          <div className="flex mb-6">
            <span className="w-16 flex items-center justify-center bg-gray-100 border border-gray-300 rounded-l-lg">
              +91
            </span>
            <input
              type="tel"
              placeholder="Phone Number"
              value={formData.phoneNumber}
              onChange={(e) =>
                setFormData({ ...formData, phoneNumber: e.target.value })
              }
              className="flex-1 p-2 border border-l-0 border-gray-300 rounded-r-lg"
            />
          </div>

          {/* Save */}
          <button
            disabled={!formData.name || !formData.phoneNumber || !isFormChanged}
            onClick={handleSave}
            className={`w-full py-3 rounded-lg font-semibold ${
              !formData.name || !formData.phoneNumber || !isFormChanged
                ? "bg-blue-200 cursor-not-allowed"
                : "bg-blue-600 hover:bg-blue-700"
            }`}
          >
            {t("save", "Save")}
          </button>

          {/* Delete */}
          {/* <button
            onClick={handleDelete}
            className="block mt-6 text-red-600 hover:underline mx-auto"
          >
            Delete Account
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default DeliveryManageAccount;
